import { ChainId } from '@pancakeswap/sdk'

export const verifyBscNetwork = (chainId: number) => {
  return chainId === ChainId.SOMNIA || chainId === ChainId.BSC_TESTNET
}
